import { createStore } from "vuex";
import { auth } from "./auth.module";

export default createStore({
  state: {
    exibeMenu: false,
    appBackgroudClass: "appBackground",
    contactFocalPoint: {
      name: "",
      contacts: {
        name: "",
        office: "",
        email: "",
        phone: "",
      },
    },
    createContactModal: {
      companies: [],
      contractee: "",
    },
    contactModal: {
      companies: [],
      contractee: "",
    },
  },
  mutations: {
    setExibeMenu(state, value) {
      state.exibeMenu = value;
    },
    setAppBackgroudClass(state, value) {
      state.appBackgroudClass = value;
    },
    setContactFocalPoint(state, value) {
      state.contactFocalPoint = value;
    },
    setCreateContactModal(state, value) {
      state.createContactModal = value;
    },
    setContactModal(state, value) {
      state.contactModal = value;
    },
  },
  actions: {
    setExibeMenu({ commit }, value) {
      commit("setExibeMenu", value);
    },
    setAppBackgroudClass({ commit }, value) {
      commit("setAppBackgroudClass", value);
    },
    setContactFocalPoint({ commit }, value) {
      commit("setContactFocalPoint", value);
    },
    setCreateContactModal({ commit }, value) {
      commit("setCreateContactModal", value);
    },
    setContactModal({ commit }, value) {
      commit("setContactModal", value);
    },
  },
  getters: {
    getExibeMenu(state) {
      return state.exibeMenu;
    },
    getAppBackgroudClass(state) {
      return state.appBackgroudClass;
    },
    getContactFocalPoint(state) {
      return state.contactFocalPoint;
    },
    getCreateContactModal(state) {
      return state.createContactModal;
    },
    getContactModal(state) {
      return state.contactModal;
    },
  },
  modules: {
    auth,
  },
});
